import { render, staticRenderFns } from "./shoufengqin.vue?vue&type=template&id=0eba4842&scoped=true"
import script from "./shoufengqin.vue?vue&type=script&lang=js"
export * from "./shoufengqin.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./shoufengqin.vue?vue&type=style&index=0&id=0eba4842&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0eba4842",
  "f544dd72"
  
)

export default component.exports